import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { ReactComponent as Storyboard } from '../../assets/images/Storyboard.svg';
import CloseIcon from '@mui/icons-material/Close';

export default function Department(props) {

    const [modalIsOpen, setIsOpen] = useState(false);
    const [show, setShow] = useState();

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {

    }

    function closeModal() {
        setIsOpen(false);
    }
    if (!props.show) {
        return null;
    } else {
      
        return (
            <React.Fragment>
                <div className="Modal">
                    <div className="ModalBg">
                        <div className="ModalContent Department">


                            <header>
                                <a href="#" onClick={() => props.onClose()}><CloseIcon className="icon" style={{ fontSize: 60, color: "black" }} /></a>
                                <h2>{props.name}</h2>
                                <p>Welcome to the {props.name} department.</p>
                            </header>
                            <section>
                                <Storyboard className="Storyboard" />
                            </section>
                            <footer>
                            </footer>


                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}